import React from 'react';
import _ from 'underscore';

import {DateInput} from 'ui-library/inputs/DatetimeInput';

import {DateFieldProps, DEFAULT_PROPS, LABEL_STYLES, SIZES} from './InputConstants';
import InputWrapper from './InputWrapper';

export default function DateField(props: DateFieldProps): JSX.Element {
  const id = _.uniqueId('dateField-');
  return (
    <InputWrapper
      button={props.button}
      className={props.className}
      description={props.description}
      id={id}
      isRequired={props.isRequired}
      label={props.label}
      labelStyle={props.labelStyle}
      size={props.size}
      help={props.help}
    >
      <DateInput
        validDatetimeInputFormats={props.validDatetimeInputFormats}
        datetimePresentationalFormat={props.datetimePresentationalFormat}
        shouldCloseOnSelect={props.shouldCloseOnSelect}
        isDisabled={props.isDisabled}
        autoFocus={props.autoFocus}
        className={props.inputClassName}
        hasButton={Boolean(props.button)}
        max={props.max}
        min={props.min}
        onChange={props.onChange}
        onKeyDown={props.onKeyDown}
        placeholder={props.placeholder}
        size={props.size}
        value={props.value ? props.value : ''}
        datePickerPopperContainerSelector={props.datePickerPopperContainerSelector}
        wrapperClassName={props.wrapperClassName}
        datetimePickerRef={props.datetimePickerRef}
      />
    </InputWrapper>
  );
}

DateField.SIZES = SIZES;
DateField.LABEL_STYLES = LABEL_STYLES;

DateField.defaultProps = {
  ...DEFAULT_PROPS,
  autoFocus: false,
  label: 'Date',
  placeholder: 'Date',
  validDatetimeInputFormats: ['YYYY-MM-DD'],
  datetimePresentationalFormat: 'YYYY-MM-DD',
};
